<template>
    <div :class="containerClasses">
        <div :class="headerClasses">
            <div class="row align-items-center">
                <div class="col-md">
                    <h4 class="font-weight-light mb-0">{{ header }}</h4>
                </div>
                <div class="col-md-auto ml-auto px-2">
                    <button :class="carouselButtonClasses" :data-target="'#' + carouselId" data-slide="prev">
                        <span class="fa fa-chevron-left align-middle icons icon-arrow-left" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </button>
                    <button :class="carouselButtonClasses" :data-target="'#' + carouselId" data-slide="next">
                        <span class="fa fa-chevron-right align-middle icons icon-arrow-right" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </button>
                </div>
            </div>
        </div>
        <div :id="carouselId" class="carousel slide my-auto" data-ride="carousel" :data-interval="carouselInterval">
            <div class="carousel-inner rounded-lg" role="listbox">
                <div v-for="(item,key) in itemList" :class="(key===0)?'carousel-item active':'carousel-item'" :key="key">
                    <div class="card rounded-lg border-0">
                        <div class="row align-items-center no-gutters">
                            <div class="col-12">
                                <div :class="'card-body ' + contentClasses">
                                    <h3 :class="headingClasses">
                                        <span :class="'display-4 font-weight-light float-right ' + item.icon"></span>
                                        {{ item.heading }}
                                    </h3>
                                    <div :class="contentClasses" v-html="item.content"></div>
                                    <a :class="buttonClasses" :href="item.url">{{ textDetails }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        containerClasses: {
            type: String,
            default: "card shadow-sm rounded-lg"
        },
        carouselId: {
            type: String,
            default: "sliderContent"
        },
        carouselInterval: {
            type: Number,
            default: 5000
        },
        carouselButtonClasses: {
            type: String,
            default: "btn btn-outline-primary btn-sm ml-2"
        },
        header: {
            type: String,
            default: "Projects"
        },
        items: {
            type: Array,
            default(){
                return [
                    {heading:"Brayton Point", content:"The cooling towers will be imploded on April 27th. The surrounding area will be closed to both public and maritime navigation.", icon:"icon-calendar", url:"./"},
                    {heading:"Upwork Redesign", content:"Adding a special incentive for writing content and some details", icon:"icon-doc", url:"./"}
                ];
            }
        },
        headerClasses: {
            type: String,
            default: "card-header bg-transparent border-bottom-0"
        },
        contentClasses: {
            type: String,
            default: "text-left text-truncate py-4"
        },
        headingClasses: {
            type: String,
            default: "mb-0"
        },
        buttonClasses: {
            type: String,
            default: "btn btn-primary"
        },
        textDetails: {
            type: String,
            default: "Details"
        }
    },
    
    data() {
        return {
          itemList: this.items||[]
        };
    }
};
</script>
